<template>
    <div class="figure-panel">
        <div class="figure-content">
            <img @click.stop="clickHanlder" :src="data.url" />
            <h4 class="figure-content-info">
                <span v-if="iconConfig.recommendType && tagId && isPubg">
                    <i
                        class="set-love-icon"
                        @mouseover="showTip = true"
                        @mouseout="showTip = false"
                        :class="{ on: data.isLove }"
                        @click="setLoveHandle"
                    ></i>
                    <Tips
                        v-show="showTip && !data.isLove"
                        :top="30"
                        :left="10"
                        :text="
                            iconConfig.recommendType === 'video'
                                ? $t('zhiji.materialLibrary.setRecommendVideo')
                                : $t('zhiji.materialLibrary.setRecommendGuide')
                        "
                    />
                </span>
                <span>{{ data.updateTime }}</span>
                <div v-show="data.amount">
                    <span>{{ data.amount | convertAmount }}</span>
                </div>
            </h4>
            <span class="figure-preview-btn" v-show="!iconConfig.hideViewIcon" @click.stop="previewClick">
                <Icon
                    class="preview-icon"
                    :width="22"
                    :height="20"
                    :bgPosition="iconConfig.previewIcon"
                    :hoverBgPosition="iconConfig.previewHoverIcon"
                ></Icon>
            </span>
        </div>
        <div class="figur-bottom-box">
            <div class="figure-header">
                <Checkbox :data="data.checked" @colClick="checkedClick" v-if="!isShowCheck" />
                <p class="figure-title" @mousemove="moveHandle" @mouseout="outHandle">{{ data.platformTitle ? data.platformTitle : data.title }}</p>
            </div>
            <div class="title-detail" v-show="showDetail">{{ data.platformTitle ? data.platformTitle : data.title }}</div>
        </div>
    </div>
</template>

<script>
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import Tips from "@/views/zhiji/bComponents/Tips";
import { isPubg } from "@/views/zhiji/js/lib/businessCheck.js";
/**
 * iconConfig:{previewIcon, previewHoverIcon, recommendType: video/tip(视频，攻略)}
 * data: 单个视频攻略卡片信息
 * tagId: 选中的标签ID
 */
export default {
    name: "FigureItem",
    props: ["data", "iconConfig", "isShowCheck", "tagId"],
    components: {
        Checkbox,
        Icon,
        Tips
    },
    data() {
        return {
            showDetail: false,
            showTip: false
        };
    },
    computed: {
        isPubg() {
            return isPubg();
        }
    },
    filters: {
        convertAmount(val) {
            return val > 1000 ? Math.round(val / 100) / 10 + "k" : val;
        }
    },
    methods: {
        checkedClick(e) {
            this.data.checked = e.checked;
            this.$emit("checkedClick", this.data);
        },
        previewClick() {
            this.$emit("previewClick", this.data);
        },
        clickHanlder() {
            this.$emit("editClick", this.data);
        },
        moveHandle() {
            this.showDetail = true;
        },
        outHandle() {
            this.showDetail = false;
        },
        setLoveHandle() {
            this.data.isLove ? this.removeRecommend() : this.setRecommend();
        },
        setRecommend() {
            this.tagId &&
                this.zhiji
                    .requestByServiceName("setRecommend", {
                        id: this.data.id,
                        type: this.iconConfig.recommendType,
                        tagId: this.tagId
                    })
                    .then(() => {
                        this.$emit("recommendSuccess");
                        this.showTip = false;
                    });
        },
        removeRecommend() {
            this.zhiji
                .requestByServiceName("removeRecommend", {
                    id: this.data.id,
                    type: this.iconConfig.recommendType
                })
                .then(() => {
                    this.$emit("recommendSuccess");
                    this.showTip = false;
                });
        }
    }
};
</script>

<style scoped lang="scss">
.figure-panel {
    width: 208px;
    display: inline-block;
    margin: 0 16px 16px 0;

    .figure-content {
        position: relative;
        border-radius: 4px;
        cursor: pointer;
        border: 1px solid #d9e4ef;

        & > img {
            width: 100%;
            height: 156px;
            min-width: 100%;
            min-height: 156px;
            background-color: #fff;
            border-radius: 4px;
        }
        .figure-content-info {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 0 auto;
            width: 100%;
            display: flex;
            justify-content: flex-start;
            padding: 0 8px;
            box-sizing: border-box;
            justify-content: space-between;
            align-items: center;
            height: 30px;
            background: #d9e4ef;
            .set-love-icon {
                display: inline-block;
                width: 14px;
                height: 12px;
                margin-right: 4px;
                vertical-align: -1px;
                background: url($zhijiStaticImagePath+"love.png") no-repeat;
                &.on {
                    background: url($zhijiStaticImagePath+"love-on.png") no-repeat;
                }
            }
        }
        .figure-preview-btn {
            position: absolute;
            bottom: 38px;
            left: 10px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 36px;
            height: 36px;
            background: rgba(255, 255, 255, 0.9);
            box-shadow: 0 2px 6px 0 rgba(46, 98, 151, 0.2);
            border-radius: 50%;
        }
    }
    .figure-header {
        display: flex;
        justify-content: start;
        align-items: center;
        margin-top: 6px;
        .figure-title {
            margin-left: 10px;
            font-size: 14px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: all;
        }
    }
    .figur-bottom-box {
        width: 100%;
        position: relative;

        .title-detail {
            position: absolute;
            background: #fff;
            border-radius: 4px;
            padding: 5px 8px;
            top: auto;
            margin-left: 25px;
            margin-top: 2px;
            text-align: center;
            white-space: normal;
            word-break: break-all;
            word-wrap: break-word;
            text-align: left;
            box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
            z-index: 1;
        }
    }
}
</style>
